import { useState } from "react";
import { Loader2, ShoppingCart } from "lucide-react";
import { toast } from "sonner";
import { clubApi, fmtEur } from "../../lib/clubApi";

// Inline "add today's sale" for a member: amount input + save button.
export default function QuickSale({ member, onSaved, autoFocus = false }) {
    const [amount, setAmount] = useState("");
    const [busy, setBusy] = useState(false);

    const save = async () => {
        const n = parseFloat(String(amount).replace(",", "."));
        if (!n || n <= 0) return toast.error("Importo non valido");
        setBusy(true);
        try {
            const r = await clubApi.registerSale({ member_id: member.id, amount: n });
            toast.success(`Vendita registrata: ${fmtEur(r.sale.amount)} · ${r.member.name}`);
            setAmount("");
            onSaved?.(r);
        } catch (e) {
            toast.error(e.response?.data?.detail || "Errore");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="flex items-center gap-2" data-testid={`quick-sale-${member.id}`}>
            <input
                type="text"
                inputMode="decimal"
                value={amount}
                autoFocus={autoFocus}
                onChange={(e) => setAmount(e.target.value.replace(/[^\d.,]/g, ""))}
                onKeyDown={(e) => e.key === "Enter" && save()}
                placeholder="Importo € di oggi"
                className="input-club-new tabular-nums flex-1 placeholder:text-stone-400"
                data-testid={`quick-sale-amount-${member.id}`}
            />
            <button
                type="button"
                onClick={save}
                disabled={busy || !amount}
                className="shrink-0 px-4 py-3 rounded-2xl bg-stone-900 text-white font-bold inline-flex items-center gap-1.5 active:scale-[0.98] disabled:opacity-50"
                data-testid={`quick-sale-save-${member.id}`}
            >
                {busy ? <Loader2 size={16} className="animate-spin" /> : <ShoppingCart size={16} />} Registra
            </button>
        </div>
    );
}
